import { createStyles, Theme } from '@nelnet/unifi-components-react';

const drawerWidth = 240;

const framestyles = ({ breakpoints }: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      position: 'relative',
    },
    rootHome: {
      flexWrap: 'wrap',
    },
    drawer: {
      backgroundColor: '#fff',
      [breakpoints.up('md')]: {
        width: `${drawerWidth}px`,
        flexShrink: 0,
      },
    },
  });

export default framestyles;
